import React, { useMemo } from 'react';
import { useHistory } from 'react-router-dom';

import { useAppContext } from '@prisjakt/ui-app-context';

import { H3Text } from '@prisjakt/ui/text/variants';
import { NavigationSliceView } from 'src/areas/product-collection/components/navigation/navigation-component';

import { Section } from './styles';

import { trackKeywordSearchPageCategoryClick } from '../../tracking';

import { TabAnchor } from '../navigation/types';
import { CategoryResultsKwlp as CategoryResultsType } from 'src/types';
import { FacetLink } from 'src/areas/product-collection/components/navigation/types';

type NewCategories = CategoryResultsType['nodes'] | undefined;

type Props = {
  categories: NewCategories;
  count: number;
  wideContent: boolean;
};

export const CategoryResults = (props: Props) => {
  const { categories, count, wideContent } = props;
  const { t, market, linkTo } = useAppContext();
  const history = useHistory();
  const categoriesFromNewSearch = categories as NewCategories;
  const formattedLinks: FacetLink[] = useMemo(
    () =>
      categoriesFromNewSearch?.map(category => {
        const link = {
          id: category?.id || '',
          value: category?.name || '',
          selected: false,
          path:
            category?.type === 'classic' && market.useClassicUrls
              ? linkTo('category', category)
              : category?.path,
          imageUrl: category?.image,
          indexable: true,
        };

        return link;
      }) ?? [],
    [categoriesFromNewSearch, linkTo, market.useClassicUrls]
  );

  return categories?.length ? (
    <Section id={TabAnchor.CATEGORIES}>
      <H3Text>{`${t('search', 'categories.title')} (${count})`}</H3Text>

      <NavigationSliceView
        links={formattedLinks}
        onClick={(link: FacetLink) => {
          if (link.path) {
            history.push(link.path);
            trackKeywordSearchPageCategoryClick(link.value, link.id);
          }
        }}
        {...(wideContent && { itemLimit: 9 })}
      />
    </Section>
  ) : null;
};
